import type { MatchParams } from '../types/match.ts'

export const pathSegmentsMatch =
  ({
    otherPathSegments,
    wildcard,
  }: {
    otherPathSegments: string[]
    wildcard: MatchParams['wildcard']
  }) =>
  (segment: string, i: number): boolean => {
    const other = otherPathSegments[i]

    if (segment.startsWith(':')) {
      return true
    }

    if (wildcard && other) {
      return other.startsWith(segment)
    }

    return segment === other
  }
